export default __webpack_public_path__ + "static/media/bgconnect.3852c582.png";